import { IconButton } from "@mui/material";
import {ReactComponent as HamburgerMenuIcon} from "../../../svgs/hamburger-menu.svg";
import {ReactComponent as BellIcon} from "../../../svgs/bell.svg";
import styles from "./header.module.scss";
import { getDate } from "../../../utils/dateUtils";

interface HeaderProps {
    handleSidebarToggle?: () => void; 
}


const Header: React.FC<HeaderProps> = ({handleSidebarToggle}) => {


    // const nthNumber = (number: number) => {
    //     if (number > 3 && number < 21) return "th";
    //     switch (number % 10) {
    //       case 1:
    //         return "st";
    //       case 2:
    //         return "nd";
    //       case 3:
    //         return "rd";
    //       default:
    //         return "th";
    //     }
    //   };
    
    // export const getDate = () => {
    //     const date = new Date();
    //     const day = date.getDate();
    //     const month = date.toLocaleString('default', { month: 'long' })
    //     const year = date.getFullYear();
    //     const fullDate = [`${day}${nthNumber(day)}`,` ${month},`, year].join(' ');
    //     return `${fullDate}`;
    // }
  

    return(
        <div className={styles.header}>
            <IconButton
              aria-label="open sidebar"
              edge="start"
              onClick={handleSidebarToggle}
              sx={{ mr: 2, visibility: { xs: 'visible', md: 'hidden' } }}
            >
              <HamburgerMenuIcon />
            </IconButton>

            <div className={styles.wrapper}>

                <span className={styles.date}>{getDate()}</span>

                {/* <span className={styles.bellWrap}><BellIcon/></span> */}
                
            </div>

            

        </div>
    )

}

export default Header;